/**
 * Central logger
 * All console output routes through here so DevTools shows this file as the
 * source (instead of each individual call-site file).
 * Logging is suppressed in production when VITE_ENABLE_CONSOLE_LOGS=false.
 */

const enabled = import.meta.env.VITE_ENABLE_CONSOLE_LOGS !== 'false';

export const logger = {
  log(...args: unknown[]): void {
    if (enabled) console.log(...args);
  },
  warn(...args: unknown[]): void {
    if (enabled) console.warn(...args);
  },
  error(...args: unknown[]): void {
    // errors always logged regardless of flag
    console.error(...args);
  },
};
